<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_INVENTORY_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết kho</h1>
      <div class="btn-group float-right">
        <button
          @click="confirmLockWarehouse(detail, 'LOCK')"
          class="f12 font-medium btn btn-outline-secondary"
          v-if="
            detail.state === 'ACTIVE' &&
            dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE') &&
            detail.level === 'EMPLOYEE'
          "
        >
          <i class="bx bx-lock"></i> Khóa kho
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3">
          <div class="form-detail" v-if="detail.id">
            <div class="d-flex justify-content-between">
              <h1>1. Thông tin kho</h1>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Cấp kho<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12">
                  {{ detail.level | transformData(listLevel) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Vùng<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12">
                  {{ detail.regionsDisplay.join(', ') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.city !== null">
              <label for="" class="col-sm-2 col-form-label"
                >Tỉnh/Thành phố<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12">{{ detail.city }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Mã kho<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12">{{ detail.code }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Tên kho<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12">{{ detail.name }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12">{{ detail.address }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Quản lý kho<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12" v-if="detail.manager !== null">
                  {{ detail.manager.name }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Thủ kho<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <p class="form-control-plaintext f12" v-if="detail.keeper !== null">
                  {{ detail.keeper.name }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-2 col-form-label"
                >Trạng thái kho<span class="float-right">:</span></label
              >
              <div class="col-sm-10">
                <span class="badge" :class="[detail.state ? detail.state : '']">
                  {{ detail.state | transformData(dataState) }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <div class="d-flex justify-content-between">
              <h1>2. Danh sách thiết bị trong kho</h1>
            </div>
            <form class="box-search mb-1" @submit="submitForm" style="padding: 0">
              <div class="form-group">
                <input
                  type="text"
                  v-model.trim="search.serial"
                  class="form-control f12 hc-37 text-search"
                  placeholder="Mã serial"
                />
              </div>

              <div class="form-group">
                <Select2
                  v-model="search.categoryId"
                  :options="optionType"
                  placeholder="Tên thiết bị"
                ></Select2>
              </div>

              <div class="form-group">
                <Select2
                  v-model="search.status"
                  :options="
                    optionStatus.filter(
                      s => !['EXPORTED', 'LENT', 'LENT_WARRANTY', 'EXPORT_RENT'].includes(s.id)
                    )
                  "
                  :settings="{ placeholder: 'Trạng thái' }"
                ></Select2>
              </div>
              <div class="form-group">
                <Select2
                  v-model="search.type"
                  :options="optionState"
                  :settings="{ placeholder: 'Tình trạng' }"
                ></Select2>
              </div>
              <div class="form-group form-group-action" style="margin-bottom: 6px">
                <button
                  @click="submitForm"
                  class="pt-2 mr-2 btn btn-primary hc-37"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Lọc"
                >
                  <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
                </button>
                <button
                  @click="removeForm"
                  type="button"
                  class="pt-2 mr-2 btn btn-outline-light hc-37"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Bỏ lọc"
                >
                  <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
                </button>
              </div>
            </form>

            Tổng: <b-link>{{ pagination?.total || 0 }}</b-link>

            <b-table
              sticky-header
              responsive
              hover
              :items="devices"
              :busy.sync="loadingTb"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
              @row-clicked="toDetail"
            >
              <template #cell(index)="data">
                {{ (pagination.page - 1) * pagination.limit + (data?.index + 1) }}
              </template>
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #cell(time)="data">
                <p>
                  <b>Thời gian tạo:</b>
                  {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Thời gian cập nhật:</b>
                  {{ data.item.dateModified | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(type)="data">
                <span class="badge" :class="[data.item.type ? data.item.type : '']">
                  {{ data.item.type | transformData(listType) }}
                </span>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | transformData(listStatus) }}
                </span>
              </template>
            </b-table>
            <div class="pagination-bottom">
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                class="mr-2 fl-right"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import catWareMixin from './catWareMixin.js'
  export default {
    mixins: [catWareMixin],
    data() {
      return {
        loading: false,
        loadingTb: false,
        id: this.$route.params.id,
        detail: {},
        devices: [],
        pagination: {
          total: 0,
          limit: 20,
          page: 1,
        },
        optionType: [],
        optionState: Config.stateDevices,
        optionStatus: Config.statusDevices,
        search: {},
        filterTable: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'categoryName', label: 'Tên thiết bị' },
          { key: 'quantity', label: 'Số lượng' },
          { key: 'serial', label: 'Mã serial' },
          { key: 'numberGear', label: 'Mã thùng' },
          { key: 'time', label: 'Thời gian' },
          { key: 'status', label: 'Trạng thái' },
          { key: 'type', label: 'Tình trạng' },
        ],
        listLevel: Config.levelWarehouse,
        listType: Config.stateDevices,
        listStatus: Config.statusDevices,
        listRegion: [],
      }
    },
    created() {
      this.typeDeviceConfig()
      this.fetchData()
      this.getRegions()
      this.getListWarehouse()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    watch: {
      'pagination.page': function () {
        this.getListWarehouse()
      },
    },
    methods: {
      backToList() {
        this.$router.push('/cat-warehouse')
      },
      async getRegions() {
        const data = await StaffService.getListRegions()
        if (data.data.length > 0) {
          this.listRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
        }
      },
      async removeForm() {
        this.search = {}
        this.pagination = {
          page: 1,
          total: 0,
          limit: 20,
        }
        await this.getListWarehouse()
      },
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        await this.getListWarehouse()
      },
      toDetail(item) {
        window.open(`/device/${item.id}`, '_blank')
      },
      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const data = await DeviceService.detailWarehouse({
            id: this.id,
          })
          if (data.success) {
            this.detail = {
              ...data.data,
              regionsDisplay: data.data.regions.map(e => this.transformData(e, this.listRegion)),
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async confirmLockWarehouse(item, typeAction) {
        const flag = await this.approveMx('Bạn có chắn chắn khóa kho này không ?')
        if (flag === true) {
          this.lockWarehouse(item, typeAction)
        }
      },
      async getListWarehouse() {
        this.loadingTb = true

        try {
          const response = await DeviceService.getListDeviceWarehouse({
            ...this.search,
            limit: this.pagination.limit,
            page: this.pagination.page,
            id: this.id,
          })
          if (response?.code === 1000) {
            this.devices = response?.data?.devices || []
            this.pagination.total = response?.data?.count || 0
          } else {
            this.showFailMx(response?.message || 'Đã có lỗi xảy ra')
          }
        } catch (error) {
          this.showFailMx(error?.message || error.response?.message || 'Đã có lỗi xảy ra')
        } finally {
          this.loadingTb = false
        }
      },

      async lockWarehouse(item, typeAction) {
        try {
          this.loading = true
          const response = await DeviceService.actionWarehouse({
            action: typeAction,
            id: item.id,
          })
          this.loading = false
          if (response?.code === 1000) {
            this.showSuccessMx('Khoá thành công')
            this.fetchData()
          } else {
            this.showFailMx(response?.message || 'Đã có lỗi xảy ra')
          }
        } catch (error) {
          this.showFailMx(error?.message || error.response?.message || 'Đã có lỗi xảy ra')
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  @import './catWare.css';
</style>
